import { COLORS } from '@constants/colors';

import { IStyles } from '@interfaces/styles';
import { useTheme } from '@mui/material';
import { ScreenSizes } from '@interfaces';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    icon: {
      color: '#FFB800',
    },
    container: {
      width: 360,
      height: 321,

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        height: 'calc(100vh - 106px)',
        maxHeight: 'calc(100dvh - 106px)',
      },
    },
    tools: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      height: 64,
      pl: 1.3125,
      pr: 1.3125,
      mt: 3.8,
      rowGap: 3.8,
      '& svg': {
        width: 37,
        height: 37,
        color: COLORS.WHITE,
      },
    },
  };
};
